import type { NotificationDatabaseEntity } from "./notification-database.type";

export const isNotificationDatabaseUnread = (
  notification: NotificationDatabaseEntity
) => {
  return notification.read_at === null;
};

export const isNotificationDatabaseRead = (
  notification: NotificationDatabaseEntity
) => {
  return !isNotificationDatabaseUnread(notification);
};
